import { GenericConfig } from '@signature-it/ngx-generic/config';
import { FormField } from './field';

export class CaptchaField extends FormField {

	siteKey: string;
	ShowAfterAttempts: number;

	constructor(options: {} = {}) {
		super(options);
		this.siteKey = GenericConfig.captchaPublicKey || 'key123456';
		this.ShowAfterAttempts = GenericConfig.captchaShowAfterAttempts || 0;
	}
}
